export const loadScript = async (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const scriptEl = document.createElement("script");
    scriptEl.src = url;
    scriptEl.onload = () => {
      resolve();
    };
    scriptEl.onerror = () => {
      reject(new Error("failed to load script at ${url}"));
    };
    document.body.appendChild(scriptEl);
  });
};
